// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","footer__link":"Footer_footer__link__Hv1-e"};